export default "__VITE_ASSET__fUGYeD1A__"